"use client";
import React from "react";
import { styled, TextField } from "@mui/material";
import { FacTextFieldProps } from "./FacTextField.type";

export const FacTextField: React.FC<FacTextFieldProps> = styled(TextField, {
    slot: "root",
    label: "FacTextField",
    name: "FacTextField",
    shouldForwardProp: (prop) => prop !== "subVariant",
})<FacTextFieldProps>``;

FacTextField.displayName = "FacTextField";

export default FacTextField;
